export default __webpack_public_path__ + "static/media/header.61ab461d.svg";